import httpService from '@/helper/httpService';
// eslint-disable-next-line
import de from 'vee-validate/dist/locale/de';

const EmptyPdf = "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/Ohne.pdf";

const maklerService = {
  title: "Maklerservice",
  type: "Makler",
  phone: "(+49) 02 21 / 37 638 - 92",
  phoneClickable: '+492213763892',
  fax: "(+49) 02 21 / 37 638 - 73 92",
  email: "maklerservice@dmb-rechtsschutz.de",
  time: "Montag - Freitag 8:00 - 18:00 Uhr"
};

const rechtService = {
  title: "DMB RECHT-Hotline",
  type: "DMB RECHT",
  subtitle: "Bei Rechtsfragen Ihrer Kunden",
  phone: "(+49) 08 00 / 36 27 32 48*",
  phoneClickable: '+4980036273248',
  time: "Montag - Freitag 8:00 - 20:00 Uhr",
  footnote: "deutschlandweit gebührenfrei"
};

const state = {
  StartseiteNews: null,
  StartseiteAuszeichnungen: null,
  ProduktePrivat: {
    "sectionTitle": "Privatkunden-RS",
    "items": [
      {
        "link": "/wp-content/uploads/tarif2026/DMB_RS_Leistungsvergleich_EXPERT_PRESTIGE_01_2026.pdf",
        "title": "Leistungsvergleich Privat-Rechtsschutz"
      },
    ]
  },
  ProduktePrivatWeitere: {
    "sections": [
      {
        "sectionTitle": "Weitere Unterlagen",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Deckungsnote_Privat_2026_L1_interaktiv.pdf",
            "title": "Deckungsauftrag Privatkunden-RS"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninfo AVI + ARB 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_SuS_261.pdf",
            "title": "Kundeninfo AVI + ARB Schnell & Sicher 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Leistungsvergleich_EXPERT_PRESTIGE_01_2026.pdf",
            "title": "Leistungsvergleich Rechtsschutz für Privatkunden"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_YOLIG_261.pdf",
            "title": "Kundeninfo AVI + ARB YOLIG 2026"
          }
        ]
      }
    ]
  },
  ProdukteGewerbe: {
    "sections": [
      {
        "sectionTitle": "Anträge/ARB/iPID",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Deckungsauftrag-Gewerbekunden-Rechtsschutz_2026_interaktiv.pdf",
            "title": "Deckungsauftrag Gewerbe-RS"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninfo AVI + ARB 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMPEX_EB_01_2026.pdf",
            "title": "KOMPEX Leistungen und Beiträge"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMPEX_Folder_01_2026.pdf",
            "title": "KOMPEX Produktinformationen"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Verkaufshilfe_KOMPEX_Grafik_01_2026.pdf",
            "title": "Verkaufshilfe Geschäftskunden Grafik"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmb_recht_forderungshilfe_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Geschäftskunden"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmbrs-deckungsauftrag-vereine-0120.pdf",
            "title": "Deckungsauftrag Vereins-RS"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Vereins-RS_Maklerinfo_01_2026.pdf",
            "title": "Maklerinformation Vereins-Rechtsschutz"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmb_recht_forderungshilfe_fuer_vereine_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Vereine"
          }
        ]
      }
    ]
  },
  ProdukteKomedex: {
    "sections": [
      {
        "sectionTitle": "Anträge/ARB/iPID",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMedEX_EB_01_2026.pdf",
            "title": "KOMedEX Leistungsmerkmale und Beiträge"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMedEX_Folder_01_2026.pdf",
            "title": "KOMedEX Produktinformationen"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninfo AVI + ARB 2026"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmb_recht_forderungshilfe_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Geschäftskunden"
          }
        ]
      }
    ]
  },
  ProdukteAgromex: {
    "sections": [
      {
        "sectionTitle": "Anträge/ARB/iPID",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AGROMEX_01_2026.pdf",
            "title": "AGROMEX Highlights und Tarifblatt"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninfo AVI + ARB 2026"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmb_recht_forderungshilfe_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Geschäftskunden"
          }
        ]
      }
    ]
  },
  ProdukteService: {
    "sections": [
      {
        "sectionTitle": "Service für Kunden",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_DMB_RECHT_Serviceleistungen_01_2026.pdf",
            "title": "DMB RECHT Serviceleistungen"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_rs_infoblatt_vorsorge-assistent_2024.pdf",
            "title": "Rechtliche persönliche Vorsorge"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_rs_infoblatt_vorsorge-_und_testamentsassistent_2025.pdf",
            "title": "Rechtliche Vorsorge mit Testamentserstellung"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Cyber-RS_01_2026.pdf",
            "title": "Cyber-Check für mehr Sicherheit im Netz"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/Gefahr-aus-dem-Netz.pdf",
            "title": "Psychologische Soforthilfe nach Cyber-Mobbing "
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_recht_forderungshilfe_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Geschäftskunden"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_rs_dmb_recht_forderungshilfe_fuer_vermieter_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für private Vermieter"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_recht_forderungshilfe_fuer_vereine_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Vereine"
          }
        ]
      }
    ]
  },
  VertriebRechtAktuell: null,
  VertriebSEPA: null,
  VertriebVerkaufshilfen: {
    "sections": [
      {
        "sectionTitle": "Verkaufshilfe/Schadenbeispiele",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_YOLIG_Kundenbroschuere_01_2026.pdf",
            "title": "Kundenbroschüre YOLIG "
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_YOLIG_Highlight-Blatt_Vertriebspartner_01_2026.pdf",
            "title": "YOLIG Highlight-Blatt"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_YOLIG_Tarifblatt_Vertriebspartner_01_2026.pdf",
            "title": "YOLIG Tarifblatt"
          },
          {
            "link": "/wp-content/uploads/historie/dmb_rs_service___produkte_kundenbroschuere_05_2022.pdf",
            "title": "Kundenbroschüre Service + Produkte"
          },
          {
            "link": "/wp-content/uploads/historie/dmb_rs_unternehmen_kundenbroschuere_05_2022.pdf",
            "title": "Kundenbroschüre Unternehmen "
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Verkaufshilfe_Privatkunden_Grafik_01_2026.pdf",
            "title": "Verkaufshilfe Privatkunden Grafik"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Verkaufshilfe_Privatkunden_Tabelle_01_2026.pdf",
            "title": "Verkaufshilfe Privatkunde Tabelle"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Leistungsvergleich_EXPERT_PRESTIGE_01_2026.pdf",
            "title": "Leistungsvergleich Privatkunden"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Cyber-RS_01_2026.pdf",
            "title": "Cyber-Rechtsschutz Highlights"
          },
          {
            "link": "/wp-content/uploads/historie/Cyberrisiko.pdf",
            "title": "Cyberrisiko: Rechtsschutz-Thema 05/2018"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMPEX_Folder_01_2026.pdf",
            "title": "Rechtsschutz für Geschäftskunden"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Verkaufshilfe_KOMPEX_Grafik_01_2026.pdf",
            "title": "Verkaufshilfe Geschäftskunden Grafik"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_DMB_RECHT_Serviceleistungen_01_2026.pdf",
            "title": "DMB RECHT Serviceleistungen"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninformationen/ ARB 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_SuS_261.pdf",
            "title": "Kundeninformationen/ ARB Schnell & Sicher 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_YOLIG_261.pdf",
            "title": "Kundeninfo AVI + ARB YOLIG 2026"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_241.pdf",
            "title": "Kundeninformationen/ ARB 2024"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb-s_s_241.pdf",
            "title": "Kundeninformationen/ ARB Schnell & Sicher 2024"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb-yolig_241.pdf",
            "title": "Kundeninfo AVI + ARB YOLIG 2024"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_221_60s-final.pdf",
            "title": "Kundeninformationen/ ARB 2022"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb-sus_221.pdf",
            "title": "Kundeninformationen/ ARB Schnell & Sicher 2022"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb-yolig_229.pdf",
            "title": "Kundeninformationen/ ARB YOLIG 2022"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_201.pdf",
            "title": "Kundeninformationen/ ARB 2020"
          },
          {
            "link": "/wp-content/uploads/historie/dmb_rs_avi-arb-s_s_201.pdf",
            "title": "Kundeninformationen/ ARB Schnell & Sicher 2020"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_181.pdf",
            "title": "Kundeninformationen/ ARB 2018"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_171.pdf",
            "title": "Kundeninformationen/ ARB 2017"
          }
        ]
      }
    ]
  },
  VertriebMaklerservice: {
    service: {
      sectionTitle: 'Service für Makler',
      persons: [
        {
          name: 'Nadine Biermann',
          rolle: 'Maklerservice & Key Account\nLandwirtschafts-Rechtsschutz',
          phone: '(+49) 02 21 / 37 638 - 12',
          phoneClickable: '+492213763812',
          fax: '',
          email: '',
          imgSrc: '/Biermann2019.jpg',
        },
        {
          name: 'Ronald Doll',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 14',
          phoneClickable: '+492213763814',
          fax: '',
          email: '',
          imgSrc: '/Doll2020.jpg',
        },
        {
          name: 'Dusica Kähler',
          rolle: 'Maklerservice & Key Account',
          phone: '(+49) 02 21 / 37 638 - 71',
          phoneClickable: '+492213763871',
          fax: '',
          email: '',
          imgSrc: '/Kaehler2019.jpg',
        },
        {
          name: 'Susann Klimpel-Hildebrandt',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 57',
          phoneClickable: '+492213763844',
          fax: '',
          email: '',
          imgSrc: '/Klimpel-Hildebrandt2019.jpg',
        },
        {
          name: 'Julia Köhler',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 29',
          phoneClickable: '+492213763829',
          fax: '',
          email: '',
          imgSrc: '/Koehler2020.jpg',
        },
        {
          name: 'Jürgen Kretschmer',
          rolle: 'Maklerservice & Key Account',
          phone: '(+49) 02 21 / 37 638 - 59',
          phoneClickable: '+492213763859',
          fax: '',
          email: '',
          imgSrc: '/Kretschmer2022.jpg',
        },
        {
          name: 'Markus Lauffs',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 39',
          phoneClickable: '+492213763839',
          fax: '',
          email: '',
          imgSrc: '/Lauffs2019.jpg',
        },
        {
          name: 'Andreas Nothhelfer',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 51',
          phoneClickable: '+492213763851',
          fax: '',
          email: '',
          imgSrc: '/',
        },
        {
          name: 'Kim Cara Schmidt',
          rolle: 'Maklerservice & Key Account',
          phone: '(+49) 02 21 / 37 638 - 7710',
          phoneClickable: '+49221376387710',
          fax: '',
          email: '',
          imgSrc: '/Schmidt2025.jpg',
        },
        {
          name: 'Michael Streckert',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 28',
          phoneClickable: '+492213763828',
          fax: '',
          email: '',
          imgSrc: '/Streckert2019.jpg',
        },
        {
          name: 'Piotr Tobola',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 43',
          phoneClickable: '+492213763843',
          fax: '',
          email: '',
          imgSrc: '/Tobola2019.jpg',
        },
        {
          name: 'Viktoria Jiménez García',
          rolle: 'Leiterin\nPartner- & Kundenservice\nKey Account & Vertriebsunterstützung\n',
          phone: '(+49) 02 21 / 37 638 - 21',
          phoneClickable: '+492213763821',
          fax: '',
          email: '',
          imgSrc: '/Jimenez2022.jpg',
        }
      ]
    },
    vorOrt: {
      sectionTitle: 'Maklerbetreuung vor Ort',
      persons: [
        {
          name: 'Peter Hofmann',
          rolle: 'Vertriebsleiter West',
          phone: '0173 / 40 38 540',
          phoneClickable: '+491734038540',
          email: 'peter.hofmann@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/peter-hofmann-dmb-rechtsschutz',
          imgSrc: '/Peter_Hofmann_2025.jpg',
          cssClass: 'profile--img',
        },
        //        {
        //          name: '',
        //          rolle: '',
        //          phone: '',
        //          phoneClickable: '',
        //          email: '',
        //          termin: '',
        //          imgSrc: '',
        //          cssClass: 'profile--img',
        //        },
        {
          name: 'Candy Huster',
          rolle: 'Manager Digitaler Vertrieb',
          phone: '0171 / 97 37 656',
          phoneClickable: '+491719737656',
          email: 'candy.huster@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/candy-huster-dmb-rechtsschutz',
          imgSrc: '/Candy_Huster_2025.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Antje Lier',
          rolle: 'Vertriebsleiterin Ost',
          phone: '0160 / 99 79 63 55',
          phoneClickable: '+4916099796355',
          email: 'antje.lier@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/antje-lier-dmb-rechtsschutz',
          imgSrc: '/Antje_Lier_2025.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Kolja Wiekhorst',
          rolle: 'Vertriebsleiter Nord',
          phone: '0171 / 777 01 86',
          phoneClickable: '+491717770186',
          email: 'kolja.wiekhorst@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/kolja-wiekhorst-dmb-rechtsschutz',
          imgSrc: '/Kolja_Wiekhorst_2025.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Sven Wiltsch',
          rolle: 'Vertriebsleiter Süd',
          phone: '0171 / 777 11 44',
          phoneClickable: '+491717771144',
          email: 'sven.wiltsch@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/sven-wiltsch-dmb-rechtsschutz',
          imgSrc: '/Sven_Wiltsch_2025.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Milan Jarosch',
          rolle: 'Leiter Vertrieb',
          phone: '0171 / 777 66 26',
          phoneClickable: '+491717776626',
          email: 'milan.jarosch@dmb-rechtsschutz.de',
          imgSrc: '/Milan_Jarosch_2025.jpg',
          cssClass: 'profile--img',
        }
      ],
    }
  },
  VertriebMaklerServiceSidebar: [
    maklerService,
    {
      title: "Anträge einreichen",
      type: "Antrag",
      phone: "",
      fax: "(+49) 02 21 / 37 638 - 73 14",
      email: "antrag@dmb-rechtsschutz.de"
    },
    rechtService,
    {
      title: "Fragen zu Schäden",
      type: "Schaden",
      phone: "(+49) 02 21 / 37 638 - 93",
      phoneClickable: '+492213763893',
      fax: "",
      email: "schaden@dmb-rechtsschutz.de"
    }
  ],
  AboutUnternehmen: null,
  AboutUnternehmenMaklerBox: maklerService,
  AboutPresse: null,
  AboutAuszeichnungen: null,
  ARB: {
    sectionTitle: "ARB",
    items: [
      {
        title: "ARB",
        link: '/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf'
      }
    ]
  },
  ARB_SUS: {
    sectionTitle: "ARB Schnell & Sicher",
    items: [
      {
        title: "ARB",
        link: '/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_SuS_261.pdf'
      }
    ]
  },
  ARB_YOLIG: {
    sectionTitle: "ARB YOLIG",
    items: [
      {
        title: "ARB YOLIG",
        link: '/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_YOLIG_261.pdf'
      }
    ]
  },
  PI_Standard: {
    sectionTitle: "Produktinformationen Standard",
    items: [
      {
        title: "Produktinformationen Standard",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_Standard_2026.pdf'
      }
    ]
  },
  PI_EXPERT: {
    sectionTitle: "Produktinformationen EXPERT",
    items: [
      {
        title: "Produktinformationen EXPERT",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_EXPERT_2026.pdf'
      }
    ]
  },
  PI_SUS: {
    sectionTitle: "Produktinformationen Schnell & Sicher",
    items: [
      {
        title: "Produktinformationen  Schnell & Sicher",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_SchnelluSicher_2026.pdf'
      }
    ]
  },
  PI_PRESTIGE: {
    sectionTitle: "Produktinformationen PRESTIGE",
    items: [
      {
        title: "Produktinformationen PRESTIGE",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_PRESTIGE_2026.pdf'
      }
    ]
  },
  PI_YOLIG: {
    sectionTitle: "Produktinformationen YOLIG",
    items: [
      {
        title: "Produktinformationen YOLIG",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_YOLIG_2026.pdf'
      }
    ]
  },
  HL_Standard: {
    sectionTitle: "Highlightblatt Standard",
    items: [
      {
        title: "Highlight-Blatt Standard",
        link: '/wp-content/uploads/tarif2026/DMB_RS_Standard_Highlight-Blatt_01_2026.pdf'
      }
    ]
  },
  HL_EXPERT: {
    sectionTitle: "Highlightblatt EXPERT",
    items: [
      {
        title: "Highlight-Blatt EXPERT",
        link: '/wp-content/uploads/tarif2026/DMB_RS_EXPERT_Highlight-Blatt_01_2026.pdf'
      }
    ]
  },
  HL_SUS: {
    sectionTitle: "Highlightblatt Schnell & Sicher",
    items: [
      {
        title: "Highlightblatt Schnell & Sicher",
        link: '/wp-content/uploads/tarif2026/DMB_RS_Schnell_u_Sicher_Highlight-Blatt_01_2026.pdf'
      }
    ]
  },
  HL_PRESTIGE: {
    sectionTitle: "Highlightblatt PRESTIGE",
    items: [
      {
        title: "Highlight-Blatt PRESTIGE",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PRESTIGE_Highlight-Blatt_01_2026.pdf'
      }
    ]
  },
  HL_YOLIG: {
    sectionTitle: "Highlightblatt YOLIG",
    items: [
      {
        title: "Highlight-Blatt YOLIG",
        link: '/wp-content/uploads/tarif2026/DMB_RS_YOLIG_Highlight-Blatt_Vertriebspartner_01_2026.pdf'
      }
    ]
  },
  nachweis_vorversicherer: {
    "sectionTitle": "Erklärung Nachweis Vorversicherer",
    "items": [
      {
        "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/dokumente/dmb-rs_schnell_und_sicher_erklaerung_nachweis_vorversicherer_1120.pdf",
        "title": "Schnell & Sicher Erklärung Nachweis Vorversicherer"
      }
    ]
  },
  EmptyPdf: EmptyPdf
};

const actions = {
  populateContent({ commit, state }, paths) {
    let requests = [];
    paths.map(path => {
      if (state[path] === null) {
        requests.push(httpService.getStaticContent(path)
          .then(result => commit("updateStaticContent", {
            path,
            newContent: result
          })));
      }
    });
    return Promise.all(requests);
  },
};

const mutations = {
  updateStaticContent(state, { path, newContent }) {
    if (path === "AboutUnternehmen") {
      state.AboutUnternehmen = convertAboutUnternehmen(newContent);
    } else {
      state[path] = newContent;
    }
  }
};

function convertAboutUnternehmen(backendContent) {
  const downloadsBoxInfo = backendContent.downloadsBox;
  return {
    content: backendContent.content,
    downloadsBox: {
      title: downloadsBoxInfo.sectionTitle,
      type: "link",
      links: downloadsBoxInfo.items
    }
  };
}

export default {
  state,
  actions,
  mutations
};
